import React from 'react'

import { AuthProvider } from './auth'
import { ToastProvider } from './toast'
import { LoadingProvider } from './loading'
import { DataTableProvider } from './dataTable'
import { TabsProvider } from './tabs'

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      <LoadingProvider>
        <TabsProvider>
          <DataTableProvider>{children}</DataTableProvider>
        </TabsProvider>
      </LoadingProvider>
    </ToastProvider>
  </AuthProvider>
)

export default AppProvider
